import { CheckIcon } from 'lucide-react';
import React from 'react';

/**
 * Simple Stepper component for onboarding flows.
 * Props:
 * - steps: Array<{ title: string, description?: string }>
 * - active: number (0-based index of active/current step)
 * - onStepClick?: (index) => void
 * - className?: additional classes for wrapper
 */
const Stepper = ({ steps = [], active = 0, className = '' }) => {
  return (
    <nav className={`w-full ${className} mb-16 px-[5%] md:px-[10%]`} aria-label='Onboarding Steps'>
      <ol className='flex items-start w-full relative'>
        {steps.map((step, idx) => {
          const isActive = idx === active;
          const isCompleted = idx < active;

          return (
            <React.Fragment key={idx}>
              {/* Step item */}
              <li className='flex flex-col items-center relative z-10 min-w-0'>
                {/* Step number circle */}
                <div
                  className={`flex items-center justify-center h-10 w-10 rounded-full border-2 flex-shrink-0 transition-colors duration-150 ${
                    isCompleted
                      ? 'bg-primary-600 border-primary-600 text-white'
                      : isActive
                      ? 'bg-white border-primary-600 text-primary-600'
                      : 'bg-white border-gray-300 text-gray-500'
                  }`}
                >
                  {isCompleted ? (
                    <CheckIcon className='h-6 w-6 text-white' />
                  ) : (
                    <span className='font-medium'>{idx + 1}</span>
                  )}
                </div>

                {/* Step text */}
                <div className='absolute top-10 mt-2 w-[100px]  md:w-fit text-center px-2'>
                  <div
                    className={`text-xs md:text-sm font-medium truncate ${
                      isActive ? 'text-gray-900' : 'text-gray-600'
                    }`}
                  >
                    {step.title}
                  </div>
                  {step.description && (
                    <div className='text-xs text-gray-500 truncate'>{step.description}</div>
                  )}
                </div>
              </li>

              {/* Progress line between steps */}
              {idx < steps.length - 1 && (
                <div
                  className={`flex-1 h-0.5 self-start mt-5  transition-colors duration-300 ${
                    idx < active ? 'bg-primary-600' : 'bg-gray-200'
                  }`}
                  aria-hidden='true'
                />
              )}
            </React.Fragment>
          );
        })}
      </ol>
    </nav>
  );
};

export default Stepper;
